export default {

    // newUserID: '101', //新用户id 测试
    newUserID: '113', //线上id 
   
}
